import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiTrendingUp, FiTarget, FiCheckCircle} = FiIcons;

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-[#F3F1EE] to-[#F3F1EE] text-[#1A1A1A] min-h-screen flex items-center">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div 
            initial={{opacity: 0, x: -50}} 
            animate={{opacity: 1, x: 0}} 
            transition={{duration: 0.8}}
            className="space-y-8"
          >
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-7xl font-bold leading-tight">
                Smarte Buchhaltung. <span className="text-[#E30613]">Online.</span>
              </h1>
              <p className="text-xl lg:text-2xl text-[#1A1A1A] leading-relaxed">
                Digitale Buchhaltung für Selbstständige – verständlich, strukturiert und ohne Stress.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <motion.a 
                href="https://nextcloud.managershop.com/index.php/apps/appointments/pub/Gb05r41McyYVyGQE/form" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{scale: 1.05}} 
                whileTap={{scale: 0.95}}
                className="bg-[#E30613] hover:bg-[#C10511] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 text-center shadow-lg"
              >
                Gespräch vereinbaren
              </motion.a>
              <motion.a 
                href="https://nextcloud.managershop.com/index.php/apps/appointments/pub/2cAlBQQqGVMD7tac/form" 
                target="_blank" 
                rel="noopener noreferrer"
                whileHover={{scale: 1.05}} 
                whileTap={{scale: 0.95}}
                className="bg-[#F3F1EE] hover:bg-[#e0dcd8] text-[#1A1A1A] px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 text-center shadow-lg border border-[#1A1A1A]"
              >
                Quick Win Workshop buchen
              </motion.a>
            </div>
            <p className="text-sm text-[#1A1A1A] max-w-2xl">
              Ich begleite dich Schritt für Schritt dabei, deine Buchhaltung digital so aufzubauen, dass du weniger Zeit brauchst, nichts mehr vergisst und jederzeit weißt, wo du finanziell stehst.<br />
              Ohne Fachchinesisch. Ohne Druck. Verständlich und in deinem Tempo.
            </p>
          </motion.div>
          <motion.div 
            initial={{opacity: 0, x: 50}} 
            animate={{opacity: 1, x: 0}} 
            transition={{duration: 0.8, delay: 0.2}}
            className="relative"
          >
            <div className="bg-white rounded-2xl p-2 shadow-2xl">
              <img 
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758140028039-Buchhaltung%20Online.png" 
                alt="Digitale Buchhaltung mit Lexware Office" 
                className="w-full h-64 object-cover rounded-lg" 
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;